<template>
  <div class="animated fadeIn pt2 pb4">
    <div v-if="showMobile">
      <div class="clearfix gibson px2 mb2">
        <div class="col-12 px2">
          <div class="clearfix border muted-border p2 shadow">
            <div class="col-12 px2">
              <p class="h4 semi-bold line-height-2 my2">Dine Ferieperioder</p>
              <p class="h6 regular darkblue line-height-golden mb3">
                Her kan du registrere ferieperioder, hvor du ikke får SMS'er eller booket møder ind til afholdelse i perioden (inkl. automatiske erstatningsmøder). Du kan registrere ferieperioder på op til 3 uger i træk og højst 6 uger i alt om året. Har du brug for at registrere flere/længere ferieperioder, så kan du få hjælp til dette ved at ringe til partnerpleje på 70 22 80 14.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix gibson px2">
        <div class="col-12 p2">
          <div class="clearfix">
            <imentor></imentor>
          </div>
        </div>
      </div>
      <div class="clearfix gibson px2 mb2">
        <div class="col-12 px2">
          <div class="clearfix border muted-border p2 shadow">
            <dineferieperioder></dineferieperioder>
          </div>
        </div>
      </div>
      <div class="py3"></div>
    </div>
    <div v-if="!showMobile">
      <div class="clearfix gibson px2">
        <div class="col-12 px2">
          <div class="clearfix p2 ml4">
            <div class="col-6 px2">
              <p class="h4 semi-bold line-height-2 my2 darkblue">Dine Ferieperioder</p>
              <p class="h5 regular darkblue line-height-golden mb3">
                Her kan du registrere ferieperioder, hvor du ikke får SMS'er eller booket møder ind til afholdelse i perioden (inkl. automatiske erstatningsmøder). Du kan registrere ferieperioder på op til 3 uger i træk og højst 6 uger i alt om året. Har du brug for at registrere flere/længere ferieperioder, så kan du få hjælp til dette ved at ringe til partnerpleje på 70 22 80 14.
              </p>
              <dineferieperioder></dineferieperioder>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix gibson px2">
        <div class="col-12 p2">
          <div class="clearfix">
            <imentor></imentor>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dineferieperioder from './DineFerieperioder'
import Imentor from './imentor'
export default {
  name: 'ferieperioder',
  components: {
    Imentor,
    dineferieperioder
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// Ferieperioder.vue?d002b65a